module.exports = __webpack_public_path__ + "img/logo_optimism.c5115824.png";